import React, { FC, useState, useEffect } from "react"
import styled from "@emotion/styled"
import Box from "@/components/Box"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
const Input = styled(Box)`
  appearance: none;
  border: none;
  background-color: transparent;
  font-family: Inter;
  font-size: 18px;
  letter-spacing: 0.02em;
  font-weight: 600;
  border: 2px solid #ced0d0;
  border-radius: 4px;
  width: 39px;
  height: 46px;
  margin-right: 16px;
  text-align: center;
  -moz-appearance: textfield;
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  &:focus {
    outline: none;
  }
`
const Chevron = styled.button<{ color: string; transform: string }>`
  position: relative;
  border: unset;
  padding: 0px;
  margin-right: 40px;
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    width: 20px;
    height: 20px;
    border-right: 2px solid ${props => props.color};
    border-bottom: 2px solid ${props => props.color};
    transform: ${props => props.transform};
    cursor: pointer;
  }
`

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: 48px;
  padding-left: 20%;
`

const Page = styled.span`
  width: 20px;
  font-weight: bold;
  font-size: 20px;
  line-height: 145%;
  color: #7d7d7d;
  cursor: pointer;
  margin-right: 30px;
`

interface Props {
  pageIndex: number
  pageSize?: number
  total: number
  onChange: (page: number) => void
}

const Pagination: FC<Props> = ({
  pageIndex,
  pageSize = 10,
  total,
  onChange,
}) => {
  const maxPage = Math.ceil(total / pageSize)
  const minPage = 1
  const page = pageIndex
  const [inputValue, setInputValue] = useState(page)
  const convertPageNum = () => {
    let currentVal = inputValue
    if (!inputValue) {
      currentVal = 1
    } else if (inputValue > maxPage) {
      currentVal = maxPage
    }
    setInputValue(currentVal)
    onChange(currentVal)
  }
  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      convertPageNum()
    }
  }

  const handleOnBlur = () => {
    convertPageNum()
  }

  const handleOnClick = (newPage: number) => {
    setInputValue(newPage)
    onChange(newPage)
  }

  useEffect(() => {
    setInputValue(page)
  }, [page])

  const inputId = `page-number-input`
  return (
    <Container dir="ltr">
      <Flex mx="auto" alignItems={"center"}>
        {total !== 0 && (
          <React.Fragment>
            <Chevron
              disabled={inputValue === minPage}
              onClick={() => handleOnClick(inputValue - 1)}
              color={inputValue === minPage ? "#9EA1A2" : "#061121"}
              transform={"rotate(135deg) translateY(50%)"}
              style={{ marginRight: "16px" }}
            />
            <label style={{ display: "none" }} htmlFor={inputId}>
              Page Number
            </label>
            <Input
              type={"number"}
              value={inputValue}
              id={inputId}
              as="input"
              pattern="[0-9]*"
              min="1"
              max={maxPage}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                setInputValue(parseInt(event.target.value))
              }
              onKeyDown={handleKeyDown}
              onBlur={handleOnBlur}
            />
            <Typography
              variant="p"
              leadingTrim
              fontSize={"18px"}
              lineHeight={"100%"}
              letterSpacing={"2%"}
              fontWeight={600}
              color={"#565F76"}
            >{`of ${maxPage}`}</Typography>
            <Chevron
              disabled={inputValue === maxPage}
              onClick={() => handleOnClick(inputValue + 1)}
              color={inputValue === maxPage ? "#9EA1A2" : "#061121"}
              transform={"rotate(-45deg) translateY(-50%)"}
              style={{ marginLeft: "48px" }}
            />
          </React.Fragment>
        )}
      </Flex>
    </Container>
  )
}

export default Pagination
